// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-card {
 background: white;
  border-radius: 14px;
  padding: 22px;
  width: 100%;
  box-shadow: 0 8px 25px rgba(0,0,0,0.08);
  transition: all 0.25s ease;
}

.modern-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 14px 30px rgba(0,0,0,0.12);
}

/* HEADER */

.modern-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}

.modern-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  gap: 10px;
}

.icon-circle {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-circle.in {
  background: linear-gradient(135deg,#00c6ff,#0072ff);
  color: white;
}

.icon-circle.out {
  background: linear-gradient(135deg,#ff6a00,#ff3c3c);
  color: white;
}

/* BUTTON */

.modern-btn {
  border: none;
  background: linear-gradient(135deg,#4f46e5,#6366f1);
  color: white;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
}

.modern-btn:hover {
  opacity: 0.9;
}

/* BODY */

.modern-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.modern-section-title {
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
  color: #888;
  margin-top: 10px;
}

/* ROW */

.modern-row {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  border-bottom: 1px dashed #eee;
}

.row-left {
  color: #444;
  font-size: 14px;
}

.count {
  margin-left: 6px;
  color: #888;
}

.row-right {
  font-weight: 600;
  color: #111;
}`, "",{"version":3,"sources":["webpack://./src/Pages/ap_auto_app/Charts/Cards/PaymentsCard.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;EAChB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA,WAAW;;AAEX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mDAAmD;EACnD,YAAY;AACd;;AAEA;EACE,mDAAmD;EACnD,YAAY;AACd;;AAEA,WAAW;;AAEX;EACE,YAAY;EACZ,mDAAmD;EACnD,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA,QAAQ;;AAER;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":[".modern-card {\n background: white;\n  border-radius: 14px;\n  padding: 22px;\n  width: 100%;\n  box-shadow: 0 8px 25px rgba(0,0,0,0.08);\n  transition: all 0.25s ease;\n}\n\n.modern-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 14px 30px rgba(0,0,0,0.12);\n}\n\n/* HEADER */\n\n.modern-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 18px;\n}\n\n.modern-title {\n  display: flex;\n  align-items: center;\n  font-size: 18px;\n  font-weight: 600;\n  gap: 10px;\n}\n\n.icon-circle {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.icon-circle.in {\n  background: linear-gradient(135deg,#00c6ff,#0072ff);\n  color: white;\n}\n\n.icon-circle.out {\n  background: linear-gradient(135deg,#ff6a00,#ff3c3c);\n  color: white;\n}\n\n/* BUTTON */\n\n.modern-btn {\n  border: none;\n  background: linear-gradient(135deg,#4f46e5,#6366f1);\n  color: white;\n  padding: 6px 14px;\n  border-radius: 6px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.modern-btn:hover {\n  opacity: 0.9;\n}\n\n/* BODY */\n\n.modern-body {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.modern-section-title {\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n  color: #888;\n  margin-top: 10px;\n}\n\n/* ROW */\n\n.modern-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 0;\n  border-bottom: 1px dashed #eee;\n}\n\n.row-left {\n  color: #444;\n  font-size: 14px;\n}\n\n.count {\n  margin-left: 6px;\n  color: #888;\n}\n\n.row-right {\n  font-weight: 600;\n  color: #111;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
